import classNames from "classnames";
import IconAsset from "../../../../components/icon/IconAsset";
import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { logAppsflyerAction } from "../../../../app/appActions";
import { FEATURES, LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";
import { getAppFeatures, getUserSelectedAccountType } from "../../../../app/appSelectors";
import SymbolFavorite from "../../../SymbolFavorite/SymbolFavorite";
import {
    LiteTradeMarketAssetRowStyled,
    LiteTradeMarketAssetSentimentProgressStyled,
    LiteTradeMarketAssetSentimentStyled,
    LiteTradeMarketAssetStyled
} from "./styled/LiteTradeMarketAssetStyled";
import {useLangContext} from "../../../../providers/LangProvider/LangProviderContext";
import LiteTradeMarketAssetPrice from './LiteTradeMarketAssetPrice';
import { locationSlice } from '../../../Location/locationReducer';
import { LOCATION_NAMES } from '../../../Location/locationConstants';
import { getIsLocationPlatformDesktopSelector } from "@/modules/Location/locationSelectors";

function LiteTradeMarketAsset(props) {
    const { getLangPath } = useLangContext();
    const {
        asset,
        collectionKey = '',
        enabledAddToFavorite = false,
        onAssetSelect,
        source = '',
        sourceEventName = '',
    } = props;
    const dispatch = useDispatch();
    const selectedAccountType = useSelector(getUserSelectedAccountType);
    const features = useSelector(getAppFeatures);
    const accountType = useSelector(getUserSelectedAccountType);
    const isPlatformDesktop = useSelector(getIsLocationPlatformDesktopSelector);

    const handleAssetSelect = useCallback((e) => {
        e.preventDefault();
        const symbol = e.currentTarget.dataset.symbol
        onAssetSelect && onAssetSelect(symbol);
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.ASSET,
            searchParams: { symbol },
        }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MARKET_ASSET_CLICK,
            payload: {
                account_type: selectedAccountType,
                collection_key: collectionKey,
                widget_key: source,
                asset: symbol,
            },
        }));
        if (isPlatformDesktop) {
            dispatch(logAppsflyerAction({
                name: LOG_AF_EVENT_NAMES.ASSET_TAB_OPEN,
                payload: {
                    account_type: accountType,
                    asset: symbol,
                    collection_key: collectionKey,
                    source: sourceEventName || source,
                },
            }));
        }
    }, [accountType, collectionKey, dispatch, isPlatformDesktop, onAssetSelect, selectedAccountType, source, sourceEventName]);

    return <LiteTradeMarketAssetStyled
        onClick={handleAssetSelect}
        className={classNames({ 'inactive': asset.inactive, 'search': source === 'asset-search' })}
        data-symbol={asset.symbol}
    >
        <LiteTradeMarketAssetRowStyled>
            <div className="col-left">
                <IconAsset symbol={asset.symbol}/>
            </div>
            <div className="col-center">
                <div className={'f16'}>{asset.info.description}</div>
                <div className={'f14 fw400 text-secondary'}>{asset.symbol}</div>
            </div>
            <div className="col-right fw600 position-relative">
                {
                    enabledAddToFavorite
                        ? <SymbolFavorite symbol={asset.symbol}/>
                        : <LiteTradeMarketAssetPrice symbol={asset.symbol}/>
                }
            </div>
        </LiteTradeMarketAssetRowStyled>
        {
            !!features[FEATURES.SENTIMENT] && source !== 'two_columns' && source !== 'asset-search' && !asset.inactive && typeof asset.sentiment === 'number' &&
            <LiteTradeMarketAssetSentimentStyled>
                <LiteTradeMarketAssetSentimentProgressStyled percent={asset.sentiment}/>
                <div className={'d-flex justify-content-between'}>
                    <div
                        className={'selling'}>{getLangPath('sentiment.side.sell', { amount: (100 - asset.sentiment).toString() })}</div>
                    <div
                        className={'buying'}>{getLangPath('sentiment.side.buy', { amount: (asset.sentiment).toString() })}</div>
                </div>
            </LiteTradeMarketAssetSentimentStyled>
        }
    </LiteTradeMarketAssetStyled>
}

export default memo(LiteTradeMarketAsset);
